class ComponentHeroCarousel extends HTMLElement {
  constructor() {
    super();
    this.slidesWrapper = this.querySelector('.keen-slider');
    this.slides = this.slidesWrapper.children;
    this.effect = this.dataset.effect;
    this.dots = this.dataset.dots;
    this.arrows = this.dataset.arrows;
    this.autoplay = this.dataset.autoplay;
    this.pauseOnHover = this.dataset.pauseOnHover!=='false';
    this.carousel = false;
    this.isInViewPort = false;

    setTimeout(()=>{ //The timeout is for the customizer
      this.initVideos();
      this.initCarousel();
    }, 1);

    this.bindCustomizerEvents();
  }

  initVideos() {
    if(this.hasVideos()) {
      this.updateVideos();

      this.slidesWrapper.querySelectorAll('.play').forEach((button)=>{
        button.addEventListener('click', ()=>{
          this.playVideo(button.closest('.video-wrap').querySelector('video'));
        });
      });
      this.slidesWrapper.querySelectorAll('.pause').forEach((button)=>{
        button.addEventListener('click', ()=>{
          this.pauseVideo(button.closest('.video-wrap').querySelector('video'));
        });
      });
      window.addEventListener('mediaChange', ()=>{this.updateVideos()});
      
      window.addEventListener('scroll', $s.throttle(()=>{
        let _isInViewPort = $s.isInViewport(this.slidesWrapper);
        if(_isInViewPort!=this.isInViewPort) {
          this.updateVideos();
        }
      }, 500));
    }
  }

  updateVideos() {
    this.isInViewPort = $s.isInViewport(this.slidesWrapper);

    var currentSlide = this.getCurrentSlide();
    if(this.isInViewPort) {
      this.loadVideos(currentSlide);
      if(this.carousel) {
        this.slidesWrapper.querySelectorAll("video").forEach((video)=>{
          this.pauseVideo(video);
        });
      }
      currentSlide.querySelectorAll('video').forEach((video)=>{
        if($s.isVisible(video)) {
          this.playVideo(video);
        }
      });
    } else {
      currentSlide.querySelectorAll('video').forEach((video)=>{
        if($s.isVisible(video)) {
          this.pauseVideo(video);
        }
      });
    }
  }

  hasVideos() {
    return this.slidesWrapper.querySelectorAll('video').length > 0;
  }

  loadVideos(slide) {
    slide.querySelectorAll('video').forEach((video)=>{
      if($s.isVisible(video) && !video.dataset.initialized) {
        var source = video.querySelector('source');
        source.setAttribute('src', source.dataset.src);
        video.dataset.initialized = true;
        video.load();
      }
    });
  }

  playVideo(video) {
    if(video) {
      let videoWrap = video.closest('.video-wrap');
      $s.playMedia(video);
      videoWrap.querySelector('.play').classList.add('hide');
      videoWrap.querySelector('.pause').classList.remove('hide');
    }
  }

  pauseVideo(video) {
    if(video) {
      let videoWrap = video.closest('.video-wrap');
      $s.pauseMedia(video);
      videoWrap.querySelector('.play').classList.remove('hide');
      videoWrap.querySelector('.pause').classList.add('hide');
    }
  }

  initCarousel() {
    if(this.slides.length > 1) {
      this.carousel = new KeenSlider(this.slidesWrapper, {
        mode: "snap",
        loop: true,
        wheel: false,
        dots: this.dots ? this.querySelector('.keen-dots') : false,
        prevButton: this.arrows ? this.querySelector('.keen-arrow.prev') : false,
        nextButton: this.arrows ? this.querySelector('.keen-arrow.next') : false,
        customAnimation: this.effect=='fade' ? 'fade' : false,
        setContainerHeight: this.effect=='fade',
        autoplay: this.autoplay,
        pauseOnHover: this.pauseOnHover,
        slideChanged: ()=>{
          if(this.hasVideos()) {
            this.updateVideos();
          }
        }
      });
    } else {
      this.slidesWrapper.classList.add('initialized');
    }
  }

  getCurrentSlide() {
    if(this.carousel && this.carousel.currentSlide()) {
      return this.carousel.currentSlide();
    } else {
      return this.slidesWrapper.firstChild;
    }
  }

  bindCustomizerEvents() {
    if(Shopify.designMode) {
      this.addEventListener('shopify:block:select', (e)=>{
        let index = Array.from(this.slides).findIndex(x=>x==e.target);
        if(index>=0) {
          setTimeout(()=>{
            this.carousel.moveToSlideRelative(index, true, 0)
          }, 10);
        }
      });
    }
  }
}
customElements.define('hero-carousel', ComponentHeroCarousel);